import { Card, List } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import useSmartNavigate from 'hooks/useSmartNavigate';
import useCustomer from 'hooks/useCustomer';
import { getImage, getCatalogCardWebpUrl } from 'helpers';
import { PRODUCTS_GRID } from 'constants/breakpoints';

const getDataCategories = (t) => [
	{
		name: t('catalog.fallbackCategories.beef'),
		image: 'catalog/cat-cover/cat-goviadina.jpg',
		path: 'govyadina',
	},
	{
		name: t('catalog.fallbackCategories.lamb'),
		image: 'catalog/cat-cover/cat-baranina.jpg',
		path: 'baranina',
	},
	{
		name: t('catalog.fallbackCategories.poultry'),
		image: 'catalog/cat-cover/cat-ptica.jpg',
		path: 'ptitsa',
	},
	{
		name: t('catalog.fallbackCategories.semiFinishedChilled'),
		image: 'catalog/cat-cover/cat-polufabricaty.jpg',
		path: 'polufabrikaty-ohlazhd',
	},
	{
		name: t('catalog.fallbackCategories.semiFinishedFrozen'),
		image: 'catalog/cat-cover/zampolufabr.jpg',
		path: 'polufabrikaty-zamorozh',
	},
	{
		name: t('catalog.fallbackCategories.sausages'),
		image: 'catalog/cat-cover/cat-kolbasy.jpg',
		path: 'kolbasnye-izdeliya',
	},
	{
		name: t('catalog.fallbackCategories.delicacies'),
		image: 'catalog/cat-cover/cat-delikatesy.jpg',
		path: 'delikatesy',
	},
	{
		name: t('catalog.fallbackCategories.culinary'),
		image: 'catalog/cat-cover/cat-kulinariya.jpg',
		path: 'kulinariya',
		nalchikOnly: true,
	},
	{
		name: t('catalog.fallbackCategories.marinades'),
		image: 'catalog/cat-cover/cat-marinady.jpg',
		path: 'marinady',
	},
	{
		name: t('catalog.fallbackCategories.petFood'),
		image: 'catalog/cat-cover/cat-korm.jpg',
		path: 'korm-dlya-zhivotnyh',
	},
	{
		name: t('catalog.fallbackCategories.accessories'),
		image: 'catalog/cat-cover/cat-copurstvuyushie.jpg',
		path: 'soputstvuyushtie-tovary',
	},
	{
		name: t('catalog.fallbackCategories.offal'),
		image: 'catalog/cat-cover/cat-subproducty.jpg',
		path: 'subprodukty',
	},
];

const Catalog = ({ breadcrumb, grid }) => {
	const { t } = useTranslation();
	const { navigate } = useSmartNavigate();
	const { customer } = useCustomer();
	const catalogCardThumbs = useSelector(
		state => state.layout.mainInfo?.data?.catalog_card_thumbs,
	);
	const isMoscow = Number(customer?.store_id) === 1;
	const dataCategories = getDataCategories(t).filter(
		item => !item.nalchikOnly || !isMoscow,
	);

	return (
		<div className='region catalog-section'>
			{breadcrumb ? (
				breadcrumb
			) : (
				<div className='contact-breadcrumb' style={{ marginTop: '64px' }}>
					<a
						href='/'
						onClick={e => {
							e.preventDefault();
							navigate('/');
						}}
						className='breadcrumb-link'
				>
					{t('common.home')}
				</a>
				<span className='breadcrumb-separator breadcrumb-separator-active'></span>
				<span className='breadcrumb-current'>{t('common.catalog')}</span>
				</div>
			)}
			<div className='catalog-section-header'>
			<h2 className='catalog-title'>{t('catalog.title')}</h2>
		</div>

			<List
				grid={grid || PRODUCTS_GRID}
				className='catalog-products-list'
				dataSource={dataCategories}
				renderItem={item => (
					<List.Item>
						<Card
							data-click-key={`cat:${item.path}`}
							onClick={() => navigate(`/catalog/${item.path}`)}
							className='catalog-card'
							bodyStyle={{ padding: 0, height: '100%', position: 'relative' }}
						>
							<img
								src={
									catalogCardThumbs?.[item.image] ||
									getCatalogCardWebpUrl(item.image)
								}
								alt=''
								className='catalog-card-image'
								onError={e => {
									if (e.target.src !== getImage(item.image)) {
										e.target.src = getImage(item.image);
									}
								}}
							/>
							<div className='catalog-card-title'>{item.name}</div>
						</Card>
					</List.Item>
				)}
			/>
		</div>
	);
};

export default Catalog;
